import { Block, Check, Delete, Edit } from '@mui/icons-material';
import { Checkbox, Chip, ListItemIcon, ListItemText, MenuItem, TableCell, TableRow, Typography } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { TableMoreMenu } from 'src/components/Table/TableMoreMenu';
import { ConfirmationDialog } from 'src/components/dialog/ConfirmationDialog';
import { renderRowCreatedAt, renderRowStatus } from 'src/utils/renderTableCell';
import { activateCourse, archieveCourse, deactiveCourse } from 'src/services';
import { useSnackbar } from 'notistack';
import {
  useHandleAbsorptionPeriodMutation,
  useUpdateBizKnowledgeMutation,
} from '../../../redux/services/CoursesServices';

export const CourseTableRow = ({ row, index, actions }) => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { cb } = actions;
  const { _id, title, status, category, tags, minLevel, teacher, duration, createdAt } = row;

  const [open, setOpen] = useState();
  const [openAlert, setOpenAlert] = useState(false);
  const [openArchieveDialog, setOpenArchieveDialog] = useState(false);

  const onDeactiveCourse = async (courseID) => {
    try {
      await deactiveCourse(courseID);
      cb();
      setOpenAlert(false);
      setOpen(null);
    } catch (error) {
      enqueueSnackbar('خطا در غیر فعال کردن دوره', { variant: 'error' });
    }
  };
  const onActivateCourse = async (courseID) => {
    try {
      await activateCourse(courseID);
      cb();
      setOpenAlert(false);
      setOpen(null);
    } catch (error) {
      enqueueSnackbar('خطا در فعال کردن دوره', { variant: 'error' });
    }
  };
  const onArchieveCourse = async (courseID) => {
    try {
      await archieveCourse(courseID);
      cb();
      setOpenAlert(false);
      setOpen(null);
    } catch (error) {
      enqueueSnackbar('خطا در حذف کردن دوره', { variant: 'error' });
    }
  };

  const handleCourseDuration = (duration) => {
    return duration;
  };

  // to prevent page from refreshing we use this state to change the checkbox value per row
  const [isAbsorptionPeriod, setAbsorptionPeriod] = useState(row.featured);
  const [isKnowledge, setIsKnowledge] = useState(row?.knowledge);

  const [handleAbsorptionPeriod, { isLoading: handleAbsorptionPeriodLoading }] = useHandleAbsorptionPeriodMutation({});
  const [updateBizKnowledge, { isLoading: isUpdateBizKnowledgeLoading }] = useUpdateBizKnowledgeMutation();

  async function handleUpdateBizKnowledge(isMake) {
    try {
      await updateBizKnowledge({
        courseID: row._id,
        action: isMake ? 'make' : 'removed',
      }).unwrap();
      setIsKnowledge((prevState) => !prevState);
      enqueueSnackbar(`دوره ${row?.title} در بیزنالج ${isMake ? 'اضافه' : 'حذف'} شد`, { variant: 'success' });
    } catch (error) {
      enqueueSnackbar(`دوره ${row?.title} در بیزنالج ${isMake ? 'اضافه' : 'حذف'} نشد`, { variant: 'error' });
    }
  }

  return (
    <>
      <TableRow key={`${title} - ${index}`} hover>
        <TableCell align="left">
          <Typography variant="body2">{index + 1}</Typography>
        </TableCell>
        <TableCell align="center">
          <Typography variant="body1" fontWeight={700}>
            {title}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography variant="body2" fontWeight={400}>
            {renderRowCreatedAt('fa-IR', createdAt)}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography variant="body1" fontWeight={400}>
            {category?.parent?.name}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography variant="body1" fontWeight={400}>
            {category?.name}
          </Typography>
        </TableCell>
        <TableCell align="center">
          {tags?.slice(0, 2)?.map((t, index) => (
            <Chip key={index} label={t?.name} sx={{ maxWidth: 100, m: 0.5 }} />
          ))}
        </TableCell>
        <TableCell align="center">
          <Typography variant="body1" fontWeight={400}>
            {minLevel?.levelName}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography variant="body1" fontWeight={400}>
            {teacher?.name}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Typography variant="body1" fontWeight={400}>
            {`${handleCourseDuration(duration)} دقیقه`}
          </Typography>
        </TableCell>
        <TableCell align="center">
          <Checkbox
            checked={isAbsorptionPeriod}
            onChange={async (event) => {
              handleAbsorptionPeriod({
                courseId: row._id,
                action: event.target.checked ? 'make' : 'removed',
              })
                .unwrap()
                .then(() => {
                  setAbsorptionPeriod((prevState) => !prevState);
                });
            }}
          />
        </TableCell>
        <TableCell align="center">
          <Checkbox
            checked={isKnowledge}
            disabled={isUpdateBizKnowledgeLoading}
            onChange={(event) => handleUpdateBizKnowledge(event.target.checked)}
          />
        </TableCell>
        <TableCell align="center">{renderRowStatus(status)}</TableCell>
        <TableCell align="right">
          {![5].includes(status) && (
            <TableMoreMenu
              open={open}
              onOpen={(e) => setOpen(e.currentTarget)}
              onClose={() => setOpen(null)}
              actions={
                <>
                  {[3].includes(status) && (
                    <MenuItem
                      onClick={() => {
                        setOpenAlert(true);
                        setOpen(null);
                      }}
                    >
                      <ListItemIcon>
                        <Block sx={{ color: '#FF4842' }} />
                      </ListItemIcon>
                      <ListItemText primary="غیر فعال سازی" sx={{ color: '#FF4842' }} />
                    </MenuItem>
                  )}
                  {[0, 1, 2, 3].includes(status) && (
                    <MenuItem
                      onClick={() => {
                        setOpenArchieveDialog(true);
                        setOpen(null);
                      }}
                    >
                      <ListItemIcon>
                        <Delete sx={{ color: '#FF4842' }} />
                      </ListItemIcon>
                      <ListItemText primary="حذف" sx={{ color: '#FF4842' }} />
                    </MenuItem>
                  )}
                  {[2, 4].includes(status) && (
                    <MenuItem
                      onClick={() => {
                        onActivateCourse(_id);
                        setOpen(null);
                      }}
                    >
                      <ListItemIcon>
                        <Check sx={{ color: '#44a427' }} />
                      </ListItemIcon>
                      <ListItemText primary="فعال سازی" sx={{ color: '#44a427' }} />
                    </MenuItem>
                  )}
                  <MenuItem onClick={() => navigate('/course/edit', { state: row })}>
                    <ListItemIcon>
                      <Edit />
                    </ListItemIcon>
                    <ListItemText primary={'ویرایش'} />
                  </MenuItem>
                </>
              }
            />
          )}
        </TableCell>
      </TableRow>
      <ConfirmationDialog
        open={openAlert}
        onClose={() => setOpenAlert(false)}
        title={<span style={{ margin: '0 1rem' }}>{`آیا میخواهید دوره ${title} را غیر فعال کنید ؟ `}</span>}
        actionTitle="بله"
        action={() => {
          onDeactiveCourse(_id);
        }}
        cancelTitle="خیر"
      />
      <ConfirmationDialog
        open={openArchieveDialog}
        onClose={() => setOpenArchieveDialog(false)}
        title={<span style={{ margin: '0 1rem' }}>{`آیا میخواهید دوره ${title} را حذف کنید ؟ `}</span>}
        actionTitle="بله"
        action={() => {
          onArchieveCourse(_id);
        }}
        cancelTitle="خیر"
      />
    </>
  );
};
